export default "__VITE_ASSET__BCAu9zk5__"